<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1vvljQ/tc-custom/9781468315387.jpg?1734323334299" alt="This image is the cover for the book Call Me Ishtar"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Call Me Ishtar
      </h1>
      <p class="bookDescription body article font2">
        <b>From the award-winning author of <i>God’s Ear</i>: A “wildly funny, achingly spiritual, profoundly Jewish and feminist” satire of religion and gender politics (<i>The New York Times Book Review</i>).</b><br/>  <br/><i>Call Me Ishtar</i> is the outrageous manifesto of a goddess determined to right the wrongs of the three-thousand-year-old patriarchy. She is Ishtar: Mother Goddess, Queen of Heaven, Angel of Death, and Whore of Babylon, and, returning to earth in this most recent incarnation, suburban housewife and sexual subversive.<br/>  <br/> Gallivanting through upstate New York, Ishtar breaks into a Hostess factory to taint its products, catapults a rock band to stardom via satanic rituals, and rises from the coffin at her own funeral—all to overthrow the worship of phallic gods and resume her former glory in this “bouncy, tongue-in-cheek mythmash of <i>The White Goddess</i> and <i>The Feminine Mystique</i>” (<i>Kirkus Reviews</i>).<br/>  <br/><b>“[Lerman’s] is a unique voice—wildly funny, achingly spiritual, profoundly Jewish and feminist at the same time.” —<i>The New York Times Book Review</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rhoda Lerman, Phyllis Rose
      </h2>
      
      <p class="authorDescription body article">Rhoda Lerman (1936&ndash;2015) is the author of several critically praised novels and works of nonfiction. In 2014, her works were heavily featured in <I>The Shelf</I> by Phyllis Rose. Lerman&#39;s novel <I>Eleanor</I>, inspired by the life of Eleanor Roosevelt, was adapted into a one woman stage play, most recently starring Loretta Swit.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?30e97c36